export const SUPPORTED_CURRENCIES = ['CHF', 'USD', 'EUR'] as const;

export type CurrencyCode = (typeof SUPPORTED_CURRENCIES)[number];

export const DEFAULT_SITE_CURRENCY: CurrencyCode = 'CHF';

export const DEFAULT_CURRENCY_RATES: Readonly<Record<CurrencyCode, number>> = {
  CHF: 1,
  USD: 0.77,
  EUR: 0.95,
};

export const DEFAULT_CURRENCY_LOCALES: Readonly<Record<CurrencyCode, string>> =
  {
    CHF: 'de-CH',
    USD: 'en-US',
    EUR: 'de-DE',
  };

export const SERVICE_PRICE_KEYS = [
  'ecommerce',
  'tech-seo',
  'analytics-schema',
  'pim',
  'wordpress',
  'ux',
  'digital-link-page',
  'cyber',
  'audit',
] as const;

export type ServicePriceKey = (typeof SERVICE_PRICE_KEYS)[number];

export type PricingEnvKey =
  | 'REACT_APP_SITE_CURRENCY'
  | 'REACT_APP_CHF_RATE'
  | 'REACT_APP_USD_RATE'
  | 'REACT_APP_EUR_RATE'
  | 'REACT_APP_SERVICE_PRICE_ECOMMERCE'
  | 'REACT_APP_SERVICE_PRICE_TECH_SEO'
  | 'REACT_APP_SERVICE_PRICE_ANALYTICS_SCHEMA'
  | 'REACT_APP_SERVICE_PRICE_PIM'
  | 'REACT_APP_SERVICE_PRICE_WORDPRESS'
  | 'REACT_APP_SERVICE_PRICE_UX'
  | 'REACT_APP_SERVICE_PRICE_DIGITAL_LINK_PAGE'
  | 'REACT_APP_SERVICE_PRICE_CYBER'
  | 'REACT_APP_SERVICE_PRICE_AUDIT';

export const RATE_ENV_KEYS = {
  CHF: 'REACT_APP_CHF_RATE',
  USD: 'REACT_APP_USD_RATE',
  EUR: 'REACT_APP_EUR_RATE',
} as const satisfies Record<CurrencyCode, PricingEnvKey>;

export const SERVICE_PRICE_ENV_KEYS = {
  ecommerce: 'REACT_APP_SERVICE_PRICE_ECOMMERCE',
  'tech-seo': 'REACT_APP_SERVICE_PRICE_TECH_SEO',
  'analytics-schema': 'REACT_APP_SERVICE_PRICE_ANALYTICS_SCHEMA',
  pim: 'REACT_APP_SERVICE_PRICE_PIM',
  wordpress: 'REACT_APP_SERVICE_PRICE_WORDPRESS',
  ux: 'REACT_APP_SERVICE_PRICE_UX',
  'digital-link-page': 'REACT_APP_SERVICE_PRICE_DIGITAL_LINK_PAGE',
  cyber: 'REACT_APP_SERVICE_PRICE_CYBER',
  audit: 'REACT_APP_SERVICE_PRICE_AUDIT',
} as const satisfies Record<ServicePriceKey, PricingEnvKey>;

export const DEFAULT_SERVICE_BASE_PRICES_CHF: Readonly<
  Record<ServicePriceKey, number>
> = {
  ecommerce: 70,
  'tech-seo': 40,
  'analytics-schema': 45,
  pim: 65,
  wordpress: 55,
  ux: 35,
  'digital-link-page': 35,
  cyber: 75,
  audit: 50,
};
